import { useCallback } from 'react';
import { useAxios } from '../useAxios';
import { AccountDailyLimits } from '../../../interfaces/models/accountActivity';

export interface IUpdateAccountActivityPayload {
  timezone?: string;
  dailyLimits?: Partial<AccountDailyLimits>;
}

export const useAccountActivityRequest = () => {
  const { sendRequest } = useAxios();

  const getAccountActivity = useCallback(() =>
    sendRequest({
      slug: 'get-account-activity',
      url: '/user/account-activity',
      method: 'GET',
      displayToast: false,
    }), [sendRequest]);

  const updateAccountActivity = useCallback((payload: IUpdateAccountActivityPayload) =>
    sendRequest({
      slug: 'update-account-activity',
      url: '/user/account-activity',
      method: 'PATCH',
      payload,
      displayToast: false,
    }), [sendRequest]);

  return { getAccountActivity, updateAccountActivity };
};
